import { syncSpatialReviews } from 'generated/api-client';
import React, { FunctionComponent, useCallback } from 'react';
import { Button, Card, Icon } from 'semantic-ui-react';
import { ToastError, ToastInfo, ToastSuccess } from 'utils';

export const SyncSpatialReviewsCard: FunctionComponent = () => {
  const onClickSyncNearestReviews = useCallback(async (): Promise<void> => {
    ToastInfo('Info', 'Synchronisation des avis...');
    await syncSpatialReviews().catch((error) => {
      if (error.status === 'Request failed with status code 504') {
        ToastInfo(
          'Info',
          'Request timeout, synchronisation des avis toujours en cours...',
        );
      } else {
        ToastError('Erreur', 'Impossible de synchroniser les avis');
        throw error;
      }
    });

    ToastSuccess('Succès', 'les avis ont été synchronisés');
  }, []);

  return (
    <Card>
      <Card.Content>
        <Icon size="large" style={{ float: 'right' }} name="comment outline" />
        <Card.Header>Synchroniser l&apos;index spatial des avis</Card.Header>
        <Card.Description>
          Synchronisation entre les avis en base de données et l&apos;index
          spatial permettant la recherche géographique.
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <Button fluid primary onClick={onClickSyncNearestReviews}>
          Exécuter
        </Button>
      </Card.Content>
    </Card>
  );
};
